import React, { useState, useEffect } from "react";
import { Dropdown, Menu } from 'antd';
import {
  EditOutlined,
  EyeOutlined,
  PlusOutlined,
  FormatPainterOutlined,
  RightOutlined,
  UndoOutlined,
  RedoOutlined,
  ScissorOutlined,
  CopyOutlined,
  SnippetsOutlined,
  SearchOutlined,
  SwapOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
  FullscreenOutlined,
  PictureOutlined,
  TableOutlined,
  LinkOutlined,
  BoldOutlined,
  ItalicOutlined,
  UnderlineOutlined,
  AlignLeftOutlined,
  AlignCenterOutlined,
  AlignRightOutlined,
} from '@ant-design/icons';
import FileMenu from "./FileMenu";
import "./NavTab.css";

const editMenu = (
  <Menu className="menu-dropdown">
    <Menu.Item key="undo">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><UndoOutlined /></span>
        <span className="menu-dropdown-item-text">Undo</span>
      </span>
    </Menu.Item>
    <Menu.Item key="redo">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><RedoOutlined /></span>
        <span className="menu-dropdown-item-text">Redo</span>
      </span>
    </Menu.Item>
    <Menu.Divider />
    <Menu.Item key="cut">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><ScissorOutlined /></span>
        <span className="menu-dropdown-item-text">Cut</span>
      </span>
    </Menu.Item>
    <Menu.Item key="copy">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><CopyOutlined /></span>
        <span className="menu-dropdown-item-text">Copy</span>
      </span>
    </Menu.Item>
    <Menu.Item key="paste">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><SnippetsOutlined /></span>
        <span className="menu-dropdown-item-text">Paste</span>
      </span>
    </Menu.Item>
    <Menu.Divider />
    <Menu.Item key="find">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><SearchOutlined /></span>
        <span className="menu-dropdown-item-text">Find</span>
      </span>
    </Menu.Item>
    <Menu.Item key="replace">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><SwapOutlined /></span>
        <span className="menu-dropdown-item-text">Replace</span>
      </span>
    </Menu.Item>
  </Menu>
);

const viewMenu = (
  <Menu className="menu-dropdown">
    <Menu.Item key="zoom-in">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><ZoomInOutlined /></span>
        <span className="menu-dropdown-item-text">Zoom In</span>
      </span>
    </Menu.Item>
    <Menu.Item key="zoom-out">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><ZoomOutOutlined /></span>
        <span className="menu-dropdown-item-text">Zoom Out</span>
      </span>
    </Menu.Item>
    <Menu.Item key="fullscreen">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><FullscreenOutlined /></span>
        <span className="menu-dropdown-item-text">Full Screen</span>
      </span>
    </Menu.Item>
  </Menu>
);

const insertMenu = (
  <Menu className="menu-dropdown">
    <Menu.Item key="image">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><PictureOutlined /></span>
        <span className="menu-dropdown-item-text">Image</span>
      </span>
    </Menu.Item>
    <Menu.Item key="table">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><TableOutlined /></span>
        <span className="menu-dropdown-item-text">Table</span>
      </span>
    </Menu.Item>
    <Menu.Item key="link">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><LinkOutlined /></span>
        <span className="menu-dropdown-item-text">Link</span>
      </span>
    </Menu.Item>
  </Menu>
);

const formatMenu = (
  <Menu className="menu-dropdown">
    <Menu.Item key="bold">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><BoldOutlined /></span>
        <span className="menu-dropdown-item-text">Bold</span>
      </span>
    </Menu.Item>
    <Menu.Item key="italic">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><ItalicOutlined /></span>
        <span className="menu-dropdown-item-text">Italic</span>
      </span>
    </Menu.Item>
    <Menu.Item key="underline">
      <span className="menu-dropdown-item">
        <span className="menu-dropdown-item-left"><UnderlineOutlined /></span>
        <span className="menu-dropdown-item-text">Underline</span>
      </span>
    </Menu.Item>
    <Menu.Divider />
    <Menu.SubMenu key="align" title={<span className="menu-dropdown-item"><span className="menu-dropdown-item-left"></span><span className="menu-dropdown-item-text">Align</span><span className="menu-dropdown-item-arrow"><RightOutlined /></span></span>}>
      <Menu.Item key="align-left">
        <span className="menu-dropdown-item">
          <span className="menu-dropdown-item-left"><AlignLeftOutlined /></span>
          <span className="menu-dropdown-item-text">Left</span>
        </span>
      </Menu.Item>
      <Menu.Item key="align-center">
        <span className="menu-dropdown-item">
          <span className="menu-dropdown-item-left"><AlignCenterOutlined /></span>
          <span className="menu-dropdown-item-text">Center</span>
        </span>
      </Menu.Item>
      <Menu.Item key="align-right">
        <span className="menu-dropdown-item">
          <span className="menu-dropdown-item-left"><AlignRightOutlined /></span>
          <span className="menu-dropdown-item-text">Right</span>
        </span>
      </Menu.Item>
    </Menu.SubMenu>
  </Menu>
);

export const NavTab = () => {
  const [selectedExportType, setSelectedExportType] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div className="navTabContainer">
      <FileMenu
        selectedExportType={selectedExportType}
        setSelectedExportType={setSelectedExportType}
      />
      <Dropdown disabled={true} overlay={editMenu} trigger={['click']} placement={isMobile ? "rightTop" : undefined}>
        <div className="navTabItem" role="menuitem" tabIndex={0}>
          <span className="nav-tab-trigger">
            <span className="nav-tab-icon"><EditOutlined /></span>
            <span className="nav-tab-label">Edit</span>
            <span className="nav-tab-arrow"><RightOutlined /></span>
          </span>
        </div>
      </Dropdown>
      <Dropdown disabled={true} overlay={viewMenu} trigger={['click']} placement={isMobile ? "rightTop" : undefined}>
        <div className="navTabItem" role="menuitem" tabIndex={0}>
          <span className="nav-tab-trigger">
            <span className="nav-tab-icon"><EyeOutlined /></span>
            <span className="nav-tab-label">View</span>
            <span className="nav-tab-arrow"><RightOutlined /></span>
          </span>
        </div>
      </Dropdown>
      <Dropdown disabled={true} overlay={insertMenu} trigger={['click']} placement={isMobile ? "rightTop" : undefined}>
        <div className="navTabItem" role="menuitem" tabIndex={0}>
          <span className="nav-tab-trigger">
            <span className="nav-tab-icon"><PlusOutlined /></span>
            <span className="nav-tab-label">Insert</span>
            <span className="nav-tab-arrow"><RightOutlined /></span>
          </span>
        </div>
      </Dropdown>
      <Dropdown disabled={true} overlay={formatMenu} trigger={['click']} placement={isMobile ? "rightTop" : undefined}>
        <div className="navTabItem" role="menuitem" tabIndex={0}>
          <span className="nav-tab-trigger">
            <span className="nav-tab-icon"><FormatPainterOutlined /></span>
            <span className="nav-tab-label">Format</span>
            <span className="nav-tab-arrow"><RightOutlined /></span>
          </span>
        </div>
      </Dropdown>
    </div>

  );
};